<template>
    <a 
        v-if="isExternalLink" v-bind="$attrs" 
        :href="to" :target="target ? '_blank' : ''" 
    >
        <slot />
    </a>
    <router-link
        v-else
        v-bind="{
            ...$attrs, 
            ...$props,
            to,
            replace
        }"
    >
        <slot />
    </router-link>
</template>
  
<script> 
import { RouterLink } from "vue-router";
 
export default {
    name: "CustomLink",
    
    inheritAttrs: false,
  
    props: {
        ...RouterLink.props,
        to: {
            type: [Object, String],
            default: null,
        },
        replace: {
            type: Boolean,
            default: false,
        },
        active: {
            type: Boolean,
            default: false,
        },
        target: {
            type: Boolean,
            default: false,
        },
    },
  
    computed: {
        isExternalLink() {
            return typeof this.to === "string" && this.to.startsWith("http");
        },
    },

    methods: {
        handleNavigate(nativeFunc) {
            // console.log({ nativeFunc });
            // if (this.customFunc) {
            //     this.customFunc();
            //     nativeFunc();
            // } else {
            //     nativeFunc();
            // }
        },
    },
};
</script>